import gql from 'graphql-tag';
import { query } from 'services/graphql';
import { surfaceDetailsFragment } from 'graphql/surface/fragments/surface-fragment';

export const surfaceHierarchyQuery = gql`
  query surfaceHierarchy($input: SurfaceHierarchyInput!) {
    surfaceHierarchy(input: $input) {
      error
      success
      data {
        ...surfaceDetails
        isShared
        surface {
          ...surfaceDetails
        }
      }
    }
  }
  ${surfaceDetailsFragment}
`;

export default query(surfaceHierarchyQuery);
